import React, {useEffect, useRef, useState} from "react";
import VaultCard from "../../../../components/dashboard/cards/vault-card/VaultCard";
import {VaultService} from "../../../../services/vault-api.service";
import dayjs from "dayjs";
import {handleDescription} from "../../../../utils/patterns";
import MastermindSkeleton from "../../../skeletons/vault/vault-pages/MastermindSkeleton";
import {useUser} from "../../../../providers/UserContext";
import NoRecord from "../../../../components/dashboard/no-record/NoRecord";
import {Button} from "antd";

export default function Podcast({ filters = {} }) {
    const { vaultSearch } = useUser();
    const [vaultData, setVaultData] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPageReached, setLastPageReached] = useState(false);
    const [loading, setLoading] = useState(false);
    const limit = 12;
    const existingIds = useRef(new Set());
    const [loader, setLoader] = useState(true);

    async function GetVaultData(type, page, limit, search) {
        setLoader(true);
        const response = await VaultService.getVault(type, page, limit, '', search, filters);
        if (response?.data?.data?.status) {
            if (page === 1) {
                existingIds.current.clear(); // Clear old IDs on a new search
                setVaultData([]); // Reset vault data
                setLastPageReached(false); // Reset pagination state
            }

            const newData = response?.data?.data?.data?.result.filter(item => {
                if (!existingIds.current.has(item._id)) {
                    existingIds.current.add(item._id);
                    return true;
                }
                return false;
            });

            setVaultData(prevData => [...prevData, ...newData]);

            if (!response?.data?.data?.data?.pagination?.hasNext) {
                setLastPageReached(true);
            }
        }
        setLoader(false);
        setLoading(false);
    }

    // Fetch data on search change or filter change
    useEffect(() => {
        setPage(1); // Reset page on new search or filter change
        GetVaultData('podcast', 1, limit, vaultSearch);
    }, [vaultSearch, filters]); // Added filters as a dependency

    // Fetch data on page change (only if it's not the first page)
    useEffect(() => {
        if (page > 1) {
            GetVaultData('podcast', page, limit, vaultSearch);
        }
    }, [page]);

    const loadMore = () => {
        if (!loading) {
            setLoading(true);
            setPage(prevPage => prevPage + 1);
        }
    };

    if (loader && vaultData.length === 0) {
        return <MastermindSkeleton />;
    }

    return (
        <div className={'vault-pages'}>
            <div className={'vault-section'}>
                {vaultData.map((item) => (
                    <VaultCard
                        key={item._id}
                        img={item.thumbnail}
                        title={handleDescription(item.name, 50)}
                        date={dayjs(item?.createdAt).format('MM-DD-YYYY')}
                        id={item._id}
                        videotime={item.length}
                        videoProgress={item.vaultWatchHistory}
                    />
                ))}
            </div>
            {vaultData.length === 0 && <NoRecord />}
            {!lastPageReached && (
                <Button type="link" className={'load-more-btn'} loading={loading} onClick={loadMore}>
                    Load More
                </Button>
            )}
        </div>
    );
}
